<template>
  <div class="search-list" v-if="imgList.length > 0">
    <div class="search-list-item" v-for="item in imgList">
      <div class="item-img">
        <el-image
          lazy="true"
          @click="clickLog(item,itemImg)"
          v-for="itemImg in item.images"
          :src="itemImg.url_small"
          :preview-src-list="getHandleImg(item.images,itemImg)">
        </el-image>
      </div>
      <div class="search-item-footer">
        <div class="search-title">
          {{item.title}}
        </div>
        <div class="search-footer-collect" @click="collectFun(item)">
          <img src="../../static/image/collect1.png" alt="" v-if="item.iscollect === 1">
          <img src="../../static/image/collect2.png" alt="" v-if="item.iscollect === 0">
          <div class="collect-number">
            {{item.collection > 999 ? '999+' : item.collection}}
          </div>
        </div>
      </div>
    </div>
    <p v-if="imgList.length === total && imgList.length > 0" class="scroll-tips">没有数据了</p>




    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="drawerFun">
      <div class="login-title">
        <h4>微信扫码登录</h4>
        <span>{{ `请在（${loginTime}）秒内扫码登录` }}</span>
      </div>
      <div class="login_container">
        <img :src="wxUrl" alt="">
      </div>
      <div class="login-tip">
        扫码登录后，收藏客户喜欢的照片，可以实时同步小程序
      </div>
    </el-dialog>

  </div>
</template>

<script>

let timer = null

export default {
  name: "ComCard",
  props:{
    imgList: Array,
    total: Number
  },
  data(){
    return {
      dialogVisible: false,
      loginTime: 0,
      openid:'',
      codeData: {},
    }
  },
  computed: {
    wxUrl() {
      return `data:image/jpeg;base64,${this.codeData.base64_image_content}`
    }
  },
  beforeRouteLeave(to, form, next) {
    this.getClearTime()
    next()
  },
  mounted(){
    if(window.localStorage.getItem('openid')){
      this.openid = window.localStorage.getItem('openid')

    }
  },
  methods:{
    drawerFun() {
      if (!this.dialogVisible) {
        this.loginTime = 90
        this.$get('/pc/shop/getUnlimit', {}).then((res) => {
          clearInterval(timer);
          timer = null
          this.codeData = res.data
          this.dialogVisible = true
          timer = setInterval(() => {
            this.loginTime--;
            if (this.loginTime <= 0) {
              this.getClearTime()
            }
            this.getWxLogin()
          }, 1000);
        }).catch((error) => {

        })

      } else {
        this.getClearTime()
      }

    },
    getClearTime() {
      this.dialogVisible = !this.dialogVisible
      clearInterval(timer);
      timer = null
    },
    getWxLogin() {
      this.$get('/pc/shop/memberInfo', {scene: this.codeData.scene}).then((res) => {
        if (res.data.is_scan_login === 1) {
          window.localStorage.setItem("openid", res.data.openid);
          this.openid = res.data.openid
          this.getClearTime()
        }
      }).catch((error) => {

      })
    },
    getHandleImg(data,img) {
      if (data.length > 0) {
        let arr = []
        data.forEach((item) => {
          if(item.id !== img.id){
            arr.push( item.url)
          }
        })
        arr.unshift(img.url)
        return arr
      }
      return []
    },
    clickLog(list, img) {
      this.$get('/pc/shop/clickLog', {packageid: list.id, imageid: img.id,phototag_id:window.getRequest().id,three_phototag_id:this.imgRequest.three_phototag_id}).then((res) => {
      })
    },
    collectFun(data) {
      let defaultOpenId = window.localStorage.getItem('openid')
      if(defaultOpenId === ''){
        this.drawerFun()
      }else {
        this.$get('/pc/shop/collect',{
          photopackage_id: data.id,
          type: data.iscollect === 1 ? 2 : 1,
        }).then((res) => {
          if (res.code === 0) {
            this.$emit('collectCall',data)
          }
        }).catch((error) => {})
      }
    },
  }
}
</script>

<style scoped lang="less">
.search-list{
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 30px;
  margin-left: -30px;
}
.search-list-item{
  width: 424px;
  height: 488px;
  background: #FFFFFF;
  border-radius: 6px;
  margin-right: 20px;
  margin-bottom: 30px;
}
.search-list-item:hover{
  transform: scale(1.05);
  transition: all 0.3s;
}
.item-img{
  box-sizing: border-box;
  height: 425px;
  padding: 10px;
  border-bottom: 2px solid  #ECECEC;
}
.el-image{
  width: 128px;
  height: 128px;
  border-radius: 4px;
  margin-right:10px;
  margin-bottom: 10px;
}
.item-img .el-image:nth-child(3n){
  margin-right: 0;
}
.search-item-footer{
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  padding: 0 20px;
}
.search-title{
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #222222;
  line-height: 39px;
}
.search-footer-collect{
  position:relative;
  display: flex;

}
.search-footer-collect img{
  width: 67px;
  height: 42px;
  margin-right: 20px;
}
.collect-number{
  position:absolute;
  top:0;
  right:0;
  width: 40px;
  height: 18px;
  line-height: 18px;
  background: #FF1717;
  border-radius: 9px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #FFFFFF;
  text-align:center;
}
.search-pagination{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 20px;
}


.login-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.login-title h4 {
  line-height: 40px;
  font-size: 30px;
  font-weight: 600;
  color: #222222;
}

.login-title span {
  margin: 20px 0;
  font-size: 20px;
  font-weight: 400;
  color: #353535;
}

.login_container {
  width: 20.83vw;
  height: 20.83vw;
  margin: 30px auto;
}

.login_container img {
  width: 20.83vw;
  height: 20.83vw;
}

.login-tip {
  margin-top: 50px;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #353535;
}


</style>



// WEBPACK FOOTER //
// src/components/ComCard.vue